export default "__VITE_ASSET__Kz1pBcVy__"